<template>
  <div>
    <b-row>
      <b-col>
        <invoice-number-card />
      </b-col>
      <b-col>
        <entry-amount-card />
      </b-col>
      <b-col>
        <price-card />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <suppliers-card />
      </b-col>
      <b-col>
        <warehouses-card />
      </b-col>
    </b-row>

  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import EntryAmountCard from '@/views/Admin/Stocks/Elements/AddLine/entry_amount.vue'
import PriceCard from '@/views/Admin/Stocks/Elements/AddLine/priceCard.vue'
import InvoiceNumberCard from '@/views/Admin/Stocks/Elements/AddLine/invoiceCard.vue'
import SuppliersCard from '@/views/Admin/Stocks/Elements/AddLine/suppliersCard.vue'
import WarehousesCard from '@/views/Admin/Stocks/Elements/AddLine/wareHousesCard.vue'

export default {
  name: 'StockLineForm',
  components: {
    WarehousesCard,
    SuppliersCard,
    InvoiceNumberCard,
    PriceCard,
    EntryAmountCard,

    BRow,
    BCol,
  },
  computed: {
    dataItem() {
      return this.$store.getters['stockLines/dataItem']
    },
    stockData() {
      return this.$store.getters['stocks/dataItem']
    },
  },
}
</script>
